// Survey.jsx
// 初回ご利用アンケート（旧Googleフォームの内製版）。
// 6つの5段階評価＋氏名/ふりがな/性別/年代/ご意見。送信で500円クーポン付与。
import { IoChevronBack } from "react-icons/io5";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Post } from '../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { Analytics, Gtag } from '../compornents/Analytics';
import { SURVEY_SCALE, surveyValue } from '../surveyScale';

const SAT = ['大変満足', '満足', '普通', 'やや不満', '大変不満'];
const REC = ['そう思う', 'ややそう思う', 'どちらでもない', 'あまり思わない', '思わない'];
const QUESTIONS = [
  { key: 'q1', label: 'このサービスの満足度', opts: SAT },
  { key: 'q2', label: '注文のしやすさ', opts: SAT },
  { key: 'q3', label: '仕上がりの品質', opts: SAT },
  { key: 'q4', label: 'お届けまでの時間', opts: SAT },
  { key: 'q5', label: 'Uber配達の速さ', opts: SAT },
  { key: 'q6', label: 'ご友人に勧めたいと思いますか', opts: REC },
];
const AGES = ['10代', '20代', '30代', '40代', '50代', '60代', '70代以上'];

export const Survey = () => {
  const navigate = useNavigate();
  const [ans, setAns] = useState({}); // q1..q6 -> 5（大変満足）..1（大変不満）
  const [name, setName] = useState('');
  const [furigana, setFurigana] = useState('');
  const [gender, setGender] = useState('');
  const [age, setAge] = useState('');
  const [comment, setComment] = useState('');
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {});

  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 10);
    (async () => {
      const r = await Post('post', '/customer/index.php', {});
      if (r && r.result === 1 && r.customer) {
        const c = r.customer;
        setName((`${c.first_name ?? ''} ${c.last_name ?? ''}`).trim() || (c.name ?? ''));
        setFurigana((`${c.first_furigana ?? ''} ${c.last_furigana ?? ''}`).trim() || (c.furigana ?? ''));
      }
    })();
  }, []);

  const back = () => navigate('/account');
  const pick = (q, v) => setAns((a) => ({ ...a, [q]: v }));

  const submit = async () => {
    for (const q of QUESTIONS) {
      if (!ans[q.key]) { toast.error('すべての評価をお選びください'); return; }
    }
    if (!name.trim() || !furigana.trim()) { toast.error('お名前・ふりがなをご入力ください'); return; }
    if (!gender) { toast.error('性別をお選びください'); return; }
    if (!age) { toast.error('年代をお選びください'); return; }
    if (!comment.trim()) { toast.error('ご意見・ご感想をご入力ください'); return; }

    openLoadingModal();
    const req = { ...ans, scale: SURVEY_SCALE, name, furigana, gender, age, comment };
    const res = await Post('post', '/customer/create_survey.php', req);
    closeLoadingModal();
    if (res && res.result === 1) {
      Gtag('survey_submit');
      if (res.coupon) {
        toast.success(`ご回答ありがとうございました！${Number(res.coupon.kingaku).toLocaleString()}円クーポンをプレゼントしました🎟️`);
      } else {
        toast.success('ご回答ありがとうございました！');
      }
      navigate('/account');
    } else {
      toast.error((res && res.error_message) || '送信に失敗しました');
    }
  };

  return (
    <div className="App">
      <div className="Address">
        <Analytics title="アンケート" />
        <div className="toolbar mb-3">
          <div className="toolbar_left div_btn" onClick={back}><IoChevronBack /></div>
          <div className="toolbar_center">アンケート</div>
          <div className="toolbar_right"></div>
        </div>
        <div className="m-4">
          <p className="svy-intro">ご回答いただくと <strong>500円クーポン</strong> をプレゼント！（お一人様1回）</p>

          {QUESTIONS.map((q, idx) => (
            <div className="svy-q" key={q.key}>
              <div className="svy-q-label"><span className="svy-q-no">Q{idx + 1}</span>{q.label}</div>
              <div className="svy-scale">
                {q.opts.map((opt, i) => {
                  const v = surveyValue(i);
                  return (
                    <button
                      type="button"
                      key={v}
                      className={`svy-chip${ans[q.key] === v ? ' is-on' : ''}`}
                      onClick={() => pick(q.key, v)}
                    >{opt}</button>
                  );
                })}
              </div>
            </div>
          ))}

          <div className="svy-q">
            <div className="svy-q-label">お名前</div>
            <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} placeholder="山田 太郎" />
          </div>
          <div className="svy-q">
            <div className="svy-q-label">ふりがな</div>
            <input type="text" className="form-control" value={furigana} onChange={(e) => setFurigana(e.target.value)} placeholder="やまだ たろう" />
          </div>
          <div className="svy-q">
            <div className="svy-q-label">性別</div>
            <div className="svy-scale">
              {[['male', '男性'], ['female', '女性'], ['other', 'その他']].map(([val, lbl]) => (
                <button type="button" key={val} className={`svy-chip${gender === val ? ' is-on' : ''}`} onClick={() => setGender(val)}>{lbl}</button>
              ))}
            </div>
          </div>
          <div className="svy-q">
            <div className="svy-q-label">年代</div>
            <select className="form-control" value={age} onChange={(e) => setAge(e.target.value)}>
              <option value="">選択してください</option>
              {AGES.map((a) => <option key={a} value={a}>{a}</option>)}
            </select>
          </div>
          <div className="svy-q">
            <div className="svy-q-label">ご意見・ご感想</div>
            <textarea className="form-control" rows={4} value={comment} onChange={(e) => setComment(e.target.value)} placeholder="ご自由にご記入ください" />
          </div>

          <div className="mb-5 mt-4">
            <button className="btn btn-oval btn-yellow form-control" onClick={submit}>送信する</button>
          </div>
        </div>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div><TailSpin stroke="#000" /></div>
            <div>処理中です</div>
          </div>
        </LoadingModal>
        <Tabbar menu="account" />
      </div>
    </div>
  );
};

export default Survey;
